import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Autocomplete, Box, Stack, TextField} from "@mui/material";
import {LicensePlateInput} from "./LicensePlateInput";
import {VinCodeInput} from "./VinCodeInput";
import {useDispatch, useSelector} from "react-redux";
import {setCarProp} from "../redux/carPropsSlice";
import {InputAdornment} from "@mui/material";
import {useTranslation} from 'react-i18next';
import {filterDetail, filterJob} from "../pages/calculatorParts/TableSums";
import {useChangesBlocker} from "../utils/useChangesBlocker";

export function CalculatorCarProps({order}) {
    const {i18n} = useTranslation();
    const currentLang = i18n.language.split('-')[0];
    const {workorder_id, mileage_old, ...orders} = order;
    const useForm = JSON.parse(sessionStorage.getItem('form'));
    const formatMileage = (val) => {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    const [mileage, setMileage] = useState(useForm.mileage && workorder_id ? formatMileage(useForm.mileage) : "");
    //const [mileage, setMileage] = useState( "");
    const [plate, setPlate] = useState("");
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);
    let isEdit = (WorkFlag === 1);

    const workID = workorder_id;
    if (!workID) isEdit = true;

    const dispatch = useDispatch();
    const useMileageType = useSelector(state => state.settings.mileageType);
    const mileageOptions = useSelector(state => state.settings.mileageOptions);
    const [selectedMileageType, setSelectedMileageType] = useState(useForm.mileageType ? useForm.mileageType : useMileageType);

    const selectedMileageTypeOption = useMemo(
        () => {
            return mileageOptions.find(opt => opt.value === selectedMileageType)
        },
        [mileageOptions, selectedMileageType]
    );

    const mileageOption = (type) => {
        return mileageOptions.find(opt => opt.value === type)
    }
    useEffect(() => {
        let mileageForm = mileage.toString().replace(/\D/g, "");
        const form = JSON.parse(sessionStorage.getItem('form'))
        const order = {...form, ...{mileage: mileageForm, mileageType: selectedMileageType}}
        sessionStorage.setItem('form', JSON.stringify(order))
        dispatch(setCarProp({
            mileage: mileageForm,
            mileageType: selectedMileageType
        }))

    }, [mileage, selectedMileageType]);

    useEffect(() => {
        const {mileage, vin, plate, mileageType, ...form} = JSON.parse(sessionStorage.getItem('form'))
        dispatch(setCarProp({
            mileage, vin, plate, mileageType
        }))
    }, [workID]);

    const handleVin = useCallback((vin) => {
        const form = JSON.parse(sessionStorage.getItem('form'))
        const order = {...form, ...{vin: vin}}
        sessionStorage.setItem('form', JSON.stringify(order))
        dispatch(setCarProp({
            vin: vin
        }))
    }, []);
    const handlePlate = useCallback((plate) => {
        const form = JSON.parse(sessionStorage.getItem('form'))
        const order = {...form, ...{plate: plate}}
        sessionStorage.setItem('form', JSON.stringify(order))
        dispatch(setCarProp({
            plate: plate
        }))
        setPlate(plate);
    }, []);

    return (
        <>

            <Stack direction={'row'} justifyContent={'start'} spacing={3} sx={{mb: 2}}>

                <Box sx={{width: 300}}>
                    <TextField
                        label={isEdit ? `Введите пробег` : 'Пробег'}
                        fullWidth
                        size="small"
                        value={mileage}
                        disabled={!isEdit}
                        onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                                setMileage('');
                                return;
                            }
                            const digits = raw.replace(/\D/g, "");
                            if (/^\d*$/.test(digits) && digits > 0) {
                                let format = formatMileage(digits);
                                setMileage(format);
                            }

                        }}
                        helperText={mileage_old ? `Показания одометра на ${new Date(orders.order_date).toLocaleDateString("ru-RU", {timeZone: 'UTC'})}: ${mileage_old} ${mileageOption(orders.mileageType)?.['label']?.[currentLang] || ''}` : null}
                        error={Boolean(!mileage && plate)}
                        InputProps={{
                            inputMode: 'numeric',
                            endAdornment: (
                                <InputAdornment position="end" sx={{ml: 1}}>
                                    <Autocomplete
                                        options={mileageOptions}
                                        getOptionLabel={(option) => option.label[currentLang]}
                                        value={selectedMileageTypeOption}
                                        onChange={(event, newValue, reason) => {
                                            setSelectedMileageType(newValue.value);
                                        }}
                                        disableClearable
                                        openOnFocus
                                        forcePopupIcon
                                        disabled={!isEdit}
                                        size="small"
                                        sx={{width: 45}}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                size="small"
                                                onKeyDown={(e) => e.preventDefault()}
                                                sx={{'.MuiInputBase-input': {padding: '2px 4px'}}}
                                            />
                                        )}
                                    />
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>
                <Box sx={{width: 300}}>
                    <LicensePlateInput handle={handlePlate}
                                       val={useForm.plate}
                                       disabled={!isEdit}
                                       errorStatus={Boolean(mileage && !plate)}/>
                </Box>
                <Box sx={{width: 300}}>
                    <VinCodeInput handle={handleVin} val={useForm.vin} disabled={!isEdit}/>
                </Box>

            </Stack>
        </>)
}